const initialCollaboratorState = {
  fetching: false,
  fetched: false,
  items: [],
  searchWord: "",
  statusCounts: { ALL: 0, GD: 0, GE: 0, SE: 0, scanOp: 0, supervisor: 0 },
  pageSize: 10,
  paginationPage: 1,
  nbResult: 0,
  yearFilter: new Date().getFullYear() - 1,
  error: null
};

export const collaboratorReducer = (
  state = initialCollaboratorState,
  action
) => {
  switch (action.type) {
    case "SET_SEARCH_WORD": {
      return { ...state, searchWord: action.searchWord };
    }
    case "FETCH_COLLABORATORS_PENDING": {
      return { ...state, fetching: true };
    }
    case "FETCH_COLLABORATORS_FULFILLED": {
      return {
        ...state,
        fetching: false,
        fetched: true,
        error: null,
        items: action.payload.data,
        nbResult: action.payload.nbResult,
        statusCounts: action.payload.statusCounts
      };
    }
    case "FETCH_COLLABORATORS_REJECTED": {
      let error = action.payload;
      switch (error.response.status) {
        case 404:
          error = {
            title: error.response.data.title,
            code: 404
          };
          break;
        default:
      }
      return {
        ...state,
        fetching: false,
        error
      };
    }
    case "SET_COLLABORATORS_LIST_PAGINATION_PAGE": {
      return { ...state, paginationPage: action.pageNumber };
    }
    case "SET_YEAR_FILTER_COLLABORATORS": {
      return {
        ...state,
        yearFilter: action.value
      };
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/collaborator.js